import styled from 'styled-components'
import { PageWrapper, Subtitle, Title, TitleWrapper } from '../Page/page.styles'
import { devices } from '../../devices'
import { Link } from 'react-router-dom'
import arrowDown from '../../assets/icon/arrow_down.svg'
import arrowDown32 from '../../assets/icon/arrow_down32.svg'
import instagramIcon from '../../assets/svg/social/instagram.svg'
import fbIcon from '../../assets/svg/social/facebook.svg'

export const SocialWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-end;
`
export const HomePageWrapper = styled(PageWrapper)`
    flex-direction: column;
    justify-content: flex-end;
    height: 100dvh;
    transition: all 0.5s linear;
`
const SocialLink = styled(Link).attrs({
    target: '_blank',
    rel: 'nofollow noopener',
})`
    display: flex;
    width: 32px;
    height: 32px;
`
export const SocialLinkFacebook = styled(SocialLink)`
    background-image: url(${fbIcon});
`
export const SocialLinkInstagram = styled(SocialLink)`
    background-image: url(${instagramIcon});
`
export const HomeTitleWrapper = styled(TitleWrapper)`
    position: relative;
    margin-top: 44px;
    margin-left: 104px;
    margin-bottom: 133px;
    @media screen and ${devices.xs} {
        margin-left: 60px;
        margin-bottom: 60px;
        position: relative;
        &:before {
            position: absolute;
            top: 24px;
            left: -36px;
            display: flex;
            content: " ";
            width: 32px;
            height: 32px;
            background-image: url(${arrowDown32});
        }
    }
    @media only screen and ${devices.ipad7thLandscape}, ${devices.ipadLandscape} {
        margin-left: 96px;
    }
    @media screen and ${devices.redmi12proPlus5gLandscape} , ${devices.iphoneSELandscape} {
        margin-top: 24px;
        margin-bottom: 44px;
        &:before {
            position: absolute;
            top: 0;
            left: -36px;
            display: flex;
            content: " ";
            width: 32px;
            height: 32px;
            background-image: url(${arrowDown32});
        }
    }
    @media only screen and ${devices.redmi12proPlus5g} {
        margin-bottom: 44px;
        &:before {
            position: absolute;
            top: 24px;
            left: -36px;
            display: flex;
            content: " ";
            width: 32px;
            height: 32px;
            background-image: url(${arrowDown32});
        }
    }
`
export const HomeSubtitle = styled(Subtitle)`
    position: relative;
    &:before {
        position: absolute;
        top: 0;
        left: -89px;
        display: flex;
        content: " ";
        width: 64px;
        height: 64px;
        background-image: url(${arrowDown});
    }
    @media only screen and ${devices.redmi12proPlus5g} {
        display: none;
    }
    @media only screen and ${devices.redmi12proPlus5gLandscape} , ${devices.iphoneSELandscape} {
        display: none;
    }
    @media only screen and ${devices.xs} {
        display: none;
    }
`
export const HomeTitle = styled(Title)`
    margin-left: 0;
    padding-top: 0;
    @media only screen and ${devices.md} {
        font-size: 54px;
        line-height: 60px;
    }
    @media only screen and ${devices.redmi12proPlus5g}{
        font-size: 24px;
        line-height: 28px; /* 116.667% */
        letter-spacing: -0.336px;
    }
    @media only screen and ${devices.redmi12proPlus5gLandscape} , ${devices.iphoneSELandscape}
    {
        font-size: 24px;
        line-height: 28px; /* 116.667% */
        letter-spacing: -0.336px;
    }
    @media only screen and ${devices.xs} {
        font-size: 24px;
        line-height: 28px; /* 116.667% */
        letter-spacing: -0.336px;
    }
`
